import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AdministrationUserGroupActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/UserGroup/UserGroupBrowser")
	}

	render() {
		return (
			<Activity 
				name="AdministrationUserGroup"
				RenderedComponent={this.RenderedComponent}
				context="AdministrationUserGroup"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AdministrationUserGroupActivity)
